var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Setting_icon",
    "data-name": "Setting icon",
    transform: "translate(-231.06 -530.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M238.56,535.49a2.08,2.08,0,1,0-.01,4.16h.01a2.08,2.08,0,1,0,0-4.16Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M243.06,530.07h-9a3,3,0,0,0-3,3v9a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3v-9A3,3,0,0,0,243.06,530.07Zm.14,8.22.22.13a1.229,1.229,0,0,1,.47,1.7l-.42.72a1.272,1.272,0,0,1-1.73.46l-.23-.12a.787.787,0,0,0-.42-.12.839.839,0,0,0-.84.84v.25a1.268,1.268,0,0,1-1.27,1.25h-.85a1.257,1.257,0,0,1-1.26-1.24v-.26a.779.779,0,0,0-.12-.41.847.847,0,0,0-1.15-.31l-.22.13a1.29,1.29,0,0,1-1.74-.46l-.42-.72a1.241,1.241,0,0,1,.47-1.71l.22-.13a.747.747,0,0,0,.31-.3.827.827,0,0,0-.31-1.14l-.22-.12v-.01a1.229,1.229,0,0,1-.47-1.7l.42-.72a1.281,1.281,0,0,1,1.74-.46l.22.12a.787.787,0,0,0,.42.12.847.847,0,0,0,.85-.84v-.25a1.253,1.253,0,0,1,1.26-1.25h.85a1.268,1.268,0,0,1,1.27,1.25v.25a.877.877,0,0,0,.11.42.853.853,0,0,0,1.15.3l.23-.13a1.29,1.29,0,0,1,1.73.46l.42.73a1.229,1.229,0,0,1-.47,1.7l-.22.13a.891.891,0,0,0-.31.3A.835.835,0,0,0,243.2,538.29Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingSidebarIcon);
export default __webpack_public_path__ + "static/media/Setting-sidebar-icon.ba37dcdd2b2be09f1303facee52106db.svg";
export { ForwardRef as ReactComponent };